import React from 'react';

const VARIANT_CLASSES = {
  default: 'border-white/10 bg-white/5',
  highlight: 'border-amber-400/30 bg-amber-500/10',
  success: 'border-emerald-400/20 bg-emerald-500/5',
  successSubtle: 'border-emerald-400/15 bg-white/5',
  danger: 'border-rose-400/30 bg-rose-500/10',
  muted: 'border-white/10 bg-white/[0.03]',
};

function cellAlignClass(align) {
  if (align === 'right') return 'text-right';
  if (align === 'center') return 'text-center';
  return 'min-w-0';
}

export default function EntityTableRow({
  row,
  idx = 0,
  columns,
  totalCols,
  variant = 'default',
  className = '',
}) {
  if (!Array.isArray(columns) || columns.length === 0) return null;
  const total = totalCols ?? columns.reduce((sum, c) => sum + (c?.colSpan || 1), 0);
  const variantClass = VARIANT_CLASSES[variant] || VARIANT_CLASSES.default;

  return (
    <div className={`rounded-lg border px-3 py-2 ${variantClass} ${className}`}>
      <div
        className="grid gap-3 items-center"
        style={{ gridTemplateColumns: `repeat(${total}, minmax(0, 1fr))` }}
      >
        {columns.map((c) => {
          const content = c?.render ? c.render(row, idx) : row?.[c?.key];
          const span = c?.colSpan && c.colSpan > 1 ? c.colSpan : null;
          return (
            <div
              key={c.key}
              className={cellAlignClass(c?.align)}
              style={span ? { gridColumn: `span ${span} / span ${span}` } : undefined}
            >
              {content == null || content === '' ? '—' : content}
            </div>
          );
        })}
      </div>
    </div>
  );
}
